import { all, takeEvery, put, call } from 'redux-saga/effects';
import actions from './actions';
import { getList, addData } from '../../helpers/fackBackend_Helper';


function* createDealerResponse({ payload: { data } }) {
    try {
        const response = yield call(addData, "/API/V1/Dealer/CreateDealer", data);
        if (response?.statusCode === 1200) {
            yield put(actions.createDealerSuccess(response?.message));
        } else {
            yield put(actions.createDealerError(response?.message || "Failed to create dealer"));
        }
    } catch (error) {
        yield put(actions.createDealerError(error));
    }
}

function* getDealerListResponse({ payload: { data } }) {
    try {
        const response = yield call(getList, `/API/V1/Dealer/GetDealerList?ActionType=${data?.actionType ?? 1}`);
        if (response?.statusCode === 1200) {
            yield put(actions.getDealerListSuccess(response.data));
        } else {
            yield put(actions.getDealerListError(response.message));
        }
    } catch (error) {
        yield put(actions.getDealerListError(error));
    }
}

function* modifyDealerResponse({ payload: { data }, }) {
    try {
        const response = yield call(addData, "/API/V1/Dealer/ModifyDealer", data);
        if (response?.statusCode === 1200) {
            yield put(actions.modifyDealerSuccess(response?.message));
        } else {
            yield put(actions.modifyDealerError(response?.message || "Failed to modify dealer"));
        }
    } catch (error) {
        yield put(actions.modifyDealerError(error?.message || error));
    }
}

function* resetPasswordByAdminResponse({ payload: { data }, }) {
    try {
        const response = yield call(addData, "/API/V1/User/ResetPasswordByAdmin", data);
        if (response?.statusCode === 1200) {
            yield put(actions.resetPasswordByAdminSuccess(response?.message));
        } else {
            yield put(actions.resetPasswordByAdminError(response?.message || "Failed to modify dealer"));
        }
    } catch (error) {
        yield put(actions.resetPasswordByAdminError(error?.message || error));
    }
}

export default function* rootSaga() {
    yield all([
        takeEvery(actions.CREATE_DEALER, createDealerResponse),
        takeEvery(actions.GET_DEALER_LIST, getDealerListResponse),
        takeEvery(actions.MODIFY_DEALER, modifyDealerResponse),
        takeEvery(actions.RESET_PASSWORD_BY_ADMIN, resetPasswordByAdminResponse),
    ]);


}
